import { fetchPost } from '~utilities/fetch';

export async function hubspotBrokerRetrySyncRequest(hubspotBrokerUuid: string): Promise<Response> {
    return fetchPost(`/hubspot-brokers/${hubspotBrokerUuid}/retry-sync`);
}